import { FileManagement } from "../models/isoFileManagment.model";
import { ISOFILEMANAGMENT } from "./actions";

const initalState = {
  isoFileList: [] as FileManagement[],
  fullIsoFileList: [] as FileManagement[],
  searchValue: "",
  uploadMediaId: null as string | null,
  uploadProgress: {
    percentage: 0,
    uploadMB: "0",
    totalMB: "0",
    name:null
  },
  pageDetails:{
    pageNumber: 1,
    totalPages: 1,
    totalRecords: 0
  }
};

const updateState = (payload: any) => {
  return {
    isoFileList: payload,
    fullIsoFileList: payload,
  };
};

export const isoFileManagementReducer = (state = initalState, action: any) => {
  switch (action.type) {
    case ISOFILEMANAGMENT.FILE_MANAGEMENT_LIST:
      return {
        ...state,
        ...updateState(action.payload?.map((i: any) => ({ ...i, checked: false }))),
      };

    case ISOFILEMANAGMENT.DELETE_LIST:
      const deleteIsoList = state.isoFileList.filter(
        (item,key) => !action.payload.includes(Number(key))
      );
       const fullList = state.fullIsoFileList.filter(
        (item,key) => !action.payload.includes(Number(key))
      );
      return {
        ...state,
        isoFileList: deleteIsoList,
        fullIsoFileList: fullList,
      };
    case ISOFILEMANAGMENT.LOCAL_SEARCH:
      const localSearch = state?.fullIsoFileList.filter(
        (item) =>
          item?.name &&
          item.name.toLowerCase().includes(action.payload.trim().toLowerCase())
      );
      return {
        ...state,
        isoFileList: localSearch,
      };
    case ISOFILEMANAGMENT.CHECK_ALL_CHECKBOX:
      const updatedCheckIsoFileList = state.isoFileList.map((item) => {
        item.checked = action.payload;
        return item;
      });

      return {
        ...state,
        ...updateState(updatedCheckIsoFileList),
      };
    case ISOFILEMANAGMENT.CHECK_SINGLE_CHECKBOX:
      const { id, value } = action.payload;
      const updatedSingleSelectIsoFileList = state.isoFileList.map(
        (item, index) => {
          if (index === id) {
            item.checked = value;
          }
          return item;
        }
      );
      return {
        ...state,
        ...updateState(updatedSingleSelectIsoFileList),
      };
    case ISOFILEMANAGMENT.SORTING_ORDER: 
      const { direction, key } = action.payload;
      const typedKey = key as keyof FileManagement;
      const sortedIsoFileList = [...state.isoFileList].sort((a, b) => {
        if (key === "size") {
          const aSize = Number(a.storageB) || 0;
          const bSize = Number(b.storageB) || 0;
          if (direction === "asc") return aSize - bSize;
          if (direction === "desc") return bSize - aSize;
          // unknown direction -> preserve order
          return 0;
        } else {
          const aVal = (a[typedKey] ?? "").toString();
          const bVal = (b[typedKey] ?? "").toString();
          // if both values are empty/invalid, preserve order
          if (!aVal && !bVal) return 0;
          if (direction === "asc") return aVal.localeCompare(bVal);
          if (direction === "desc") return bVal.localeCompare(aVal);
          // unknown direction -> preserve order
          return 0;
        }
      });
      return {
        ...state,
        ...updateState(sortedIsoFileList),
      };
    case ISOFILEMANAGMENT.SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload,
      };
    case ISOFILEMANAGMENT.UPLOAD_LOADER:
       return {
        ...state,
        uploadProgress: {
           percentage: action.payload.percentage,
           uploadMB: action.payload.uploadMB,
           totalMB: action.payload.totalMB,
           name: action.payload.name
        },
      };
    case ISOFILEMANAGMENT.PAGE_DETAILS:
      return {
        ...state,
        pageDetails: action.payload,
      };
    case 'SET_UPLOAD_PROGRESS_MEDIA_ID':
      return {
        ...state,   
        uploadMediaId: action.payload
      }
    default:
      return state;
  }
};
